import { TextCell } from '@common/components/TextCell';

interface PhoneCellProps {
	phone?: string;
}

export const PhoneCell = ({ phone }: PhoneCellProps) => {
	return <TextCell value={phone} />;
};
